import isShopInPathname from './isShopInPathname';

export const PIXELS = {
  gtm: 'gtm',
  klaviyo: 'klaviyo',
  adroll: 'adroll',
  rakuten: 'rakuten',
};

/**
 * Is pixel installed on a site and allowed to fire pixel events.
 * Typically, wraps pixel code in shared site components
 * NEXT_PUBLIC_ALLOW_LIST_PIXELS | GATSBY_ALLOW_LIST_PIXELS is
 * comma separated env list -> `gtm,klaviyo,adroll`
 *
 */
export function isPixelSupported(pixelName: string): boolean {
  if (!pixelName) return false;
  const allowList = `${
    process.env.NEXT_PUBLIC_ALLOW_LIST_PIXELS ||
    process.env.GATSBY_ALLOW_LIST_PIXELS
  }`
    .toLowerCase()
    .split(',');
  return allowList.includes(pixelName);
}

// passing in window.location if possible
interface Location {
  pathname?: string;
  search?: string;
}

export function pixelCategoryFromLocation(location?: Location): string {
  if (!location?.pathname) return '';

  const locationPathname = location?.pathname || '';
  const locationSearch = location?.search || '';

  return isShopInPathname(locationPathname)
    ? locationPathname // collection page
    : new URLSearchParams(locationSearch).get(
        // pdp page
        'collection-location'
      ) || '';
}

export const waitForKlaviyo = (callback: () => void, timeout = 1000) => {
  const start = Date.now();
  const interval = setInterval(() => {
    const ready = !!(
      globalThis?.klaviyo && typeof globalThis?.klaviyo.push === 'function'
    );
    if (ready) {
      clearInterval(interval);
      callback();
    } else if (Date.now() - start > timeout) {
      clearInterval(interval);
      console.warn('Klaviyo not ready after timeout.');
    }
  }, 100);
};
